import { useState, useEffect } from 'react';

const useUserInfo = (apiUrl) => {
  const [userInfo, setUserInfo] = useState({ first_name: '', last_name: '', email: '', is_subscribed: '', is_authenticated: null, is_loading: true });

  useEffect(() => {
    const fetchUserInfo = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setUserInfo((prev) => ({ ...prev, is_authenticated: false, is_loading: false }));
        return;
      }
      
      try {
        const response = await fetch(`${apiUrl}/user_info`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (!response.ok) {
          throw new Error('Failed to fetch user info');
        }
        const data = await response.json();
        data.is_authenticated = true;
        data.is_loading = false;
        setUserInfo(data);
      } catch (error) {
        console.error('Error fetching user info:', error);
        localStorage.removeItem('token'); // Remove invalid token
        setUserInfo((prev) => ({ ...prev, is_authenticated: false, is_loading: false }));
      }
    };

    fetchUserInfo();
  }, [apiUrl]);
  console.log('userInfo', userInfo);
  return userInfo;
};

export default useUserInfo;

